import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as moment from 'moment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlatformLocation } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { TokenService } from 'src/services/token.service';

@Component({
  selector: 'app-schooling',
  templateUrl: './schooling.component.html',
  styleUrls: ['./schooling.component.scss']
})
export class SchoolingComponent implements OnInit {

  form: FormGroup;
  formEducation: FormGroup;

  // formEducation: FormGroup;
  editMode: boolean = false;
  submiting: boolean = false;
  educations$: Observable<any>;
  mauticFormSrc: any = null;

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private pLocation: PlatformLocation,
    private sanitazer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<SchoolingComponent>,
    private TokenService: TokenService
  ) {
    this.form = fb.group({
      Leveleducation: [null, Validators.required],
    })

    this.formEducation = fb.group({
      id: [null],
      lead_id: [Validators.required],
      institutionName: [null, Validators.required],
      educationLevel: [null, Validators.required],
      courseName: [null],
      currentCourse: [false, Validators.required],
      dateStart: [null, [Validators.required, CustomValidators.beforeDate('dateEnd', 'MMyyyy'), CustomValidators.date('MMyyyy')]],
      dateEnd: [null, [CustomValidators.departureDate('currentCourse'), CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy')]],
    })

  }

  ngOnInit(): void {

    if (this.data) {
      this.editable(true)
    }

    const token = JSON.parse(localStorage.getItem('token'));
    let subject = new Subject();
    subject.subscribe(
      (result: any) => {
        const { trigger, scope } = result;

        if (scope === 'education') {

          if (trigger === 'pre') {
            this.formEducation.disable();
            this.submiting = true;
          } else {
            this.formEducation.enable();
            this.submiting = false;
          }
        }
      }
    );

    this.http.setLoadingIndicator(subject);
    this.formEducation.patchValue({ lead_id: token.id });
    this.formEducation.get('currentCourse')
      .valueChanges
      .subscribe(_ => this.formEducation.patchValue({ dateEnd: null }));

    this.getSchooling();
    this.getLevelSchooling();
  }

  private getSchooling() {

    const token = JSON.parse(localStorage.getItem('token'));
    this.educations$ = this.http.get('education', { id: token.id, all: true })
      .pipe(map((result: any) => {
        // console.log(result.data);
        this.submiting = false;
        return result.data
      }));

  }

  private getLevelSchooling() {

    const token = JSON.parse(localStorage.getItem('token'));
    this.http.get('levelschool', { id: token.id })
      .subscribe(
        (result: any) => {
          const { data } = result;

          this.form.patchValue({
            Leveleducation: data.leveleducation,
          },
            { emitEvent: false }
          );
        })

  }

  editEducation(education) {

    if (this.editMode && (education.id != this.formEducation.get('id').value)) {
      if (!confirm('O formulário ainda está em edição, verifique se há dados alterados antes de continuar a próxima edição. Deseja continuar'))
        return;
    }

    this.editable(true);
    this.formEducation.patchValue({
      id: education.id,
      institutionName: education.institution_name,
      educationLevel: education.education_level,
      courseName: education.course_name,
      currentCourse: education.date_end === null,
      dateStart: moment(education.date_start, 'YYYY-MM-DD').format('MM/YYYY'),
      dateEnd: education.date_end ? moment(education.date_end, 'YYYY-MM-DD').format('MM/YYYY') : null,
    })

  }

  editable(editable: boolean) {

    this.editMode = editable;
    const token = JSON.parse(localStorage.getItem('token'));
    this.formEducation.reset({ lead_id: token.id, currentCourse: false })

    if (editable)
      this.formEducation.markAsPristine();

    this.formEducation.enable();

  }

  removeEducation(education: any) {

    if (!confirm(`Deseja realmente deletar ${education.course_name.toUpperCase()}?`))
      return;

    this.http.delete('education', { id: education.id })
      .subscribe(
        (result: any) => {

          if (result.type === 'OK' && result.data > 0) {
            this.snackbar.open('Curso excluido com sucesso!', 'OK', { duration: 3000 });
            this.getSchooling();
            this.editable(false);
          } else this.snackbar.open('Não foi possivel deletar esse curso, tente novamente mais tarde !', 'OK', { duration: 3000 });
        },
        err => this.errorReport.showMessage(err)
      )

  }

  submitSchooling() {

    const data = this.formEducation.getRawValue();
    const isValid = !this.formEducation.invalid;

    if (isValid) {

      data.dateStart = moment(data.dateStart, 'MMYYYY').format('YYYY-MM-DD');

      if (data.dateEnd)
        data.dateEnd = moment(data.dateEnd, 'MMYYYY').format('YYYY-MM-DD');
      data['showInfo'] = true;

      const request$ = data.id
        ? this.http.save('education:update', data)
        : this.http.save('education', data)

      request$.subscribe(
        (result: any) => {

          if (result.type === 'OK') {
            this.snackbar.open('Adicionado com sucesso! ', 'OK', { duration: 3000 });
            this.getSchooling();
            this.editable(false);

            this.TokenService.atualizar();

            const params = new URLSearchParams();
            const token = JSON.parse(localStorage.getItem('token'));
            params.append('email', token.email);
            params.append('passo', '3');
    
            const hBase = this.pLocation.getBaseHrefFromDOM();
      
            this.mauticFormSrc = this.sanitazer
              .bypassSecurityTrustResourceUrl(`${hBase}mautic-form/progress?${params.toString()}`);
      
          }
        },
        err => this.errorReport.showMessage(err)
      );

    }

  }

  submitLevelEducattion() {
    setTimeout(() => {
      const token = JSON.parse(localStorage.getItem('token'));
      const isValid = !this.form.invalid;
      if (isValid) {

        const level = this.form.get('Leveleducation').value;
        const info = {
          email: token.email,
          educationLevel: level
        }

        this.http.save('education_level', info)
          .subscribe(
            (result: any) => {
              if (result.type === 'OK') {
                this.snackbar.open('Escolaridade salva com sucesso.', 'OK', { duration: 3000 });

                this.form.markAsPristine();
              }
            }
          );

      }

    }, 1000)
  }

  close() {
    this.dialogRef.close();
  }

}
